import { GridItem, Text } from "@chakra-ui/react";

function CategoryGridHeaderRow({ isPreview, columnHeaders }) {
  return columnHeaders.map(headerTitle => {
    return <GridItem
      key={`heading-${headerTitle}`}
      px={4}
      py={3}
      display="flex"
      alignItems="center"
      bg="gray.50"
      borderBottom="1px solid"
      borderColor="gray.200"
      colSpan={isPreview ? 2 : headerTitle !== "" ? 2 : 1}
      position="sticky"
      top={0}
      zIndex={2}
    >
      <Text
        fontSize="13px"
        fontWeight="600"
        color="gray.500"
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        title={typeof headerTitle === "string" ? headerTitle : ""}
      >
        {headerTitle}
      </Text>
    </GridItem>;
  });
}

export default CategoryGridHeaderRow;
